<div class="inner-page-sidenav">
    <nav class="navbar navbar-expand-lg pb-2 py-lg-0" aria-label="Offcanvas navbar large">
        <button class="navbar-toggler sidemenu-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar"
            aria-controls="offcanvasSidebar">
           <i class="bi bi-layout-text-sidebar"></i>
            Side Menu
        </button>
        <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSidebar"
            aria-labelledby="offcanvasSidebarLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasSidebarLabel">Side Menu</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
                    aria-label="Close"></button>
            </div> 
            <div class="offcanvas-body">
                <ul class="navbar-nav">

                    <li class="nav-item font-adjust">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/wheat"]'>
                           {{'Procurement' | translate}}  
                        </a>
                    </li>
                  
                    <li class="nav-item font-adjust">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/stock"]'>
                            {{'Stock' | translate }}
                        </a>
                    </li>
                    <li class="nav-item font-adjust">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/quality-control"]'>
                            {{'QualityControl' | translate }} 
                        </a>
                    </li>
                    <li class="nav-item font-adjust">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/movement"]'>
                            {{'Movement' | translate }}
                        </a>
                    </li>
                    <li class="nav-item font-adjust">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/ir-l"]'>
                            {{'IR-L' | translate }} 
                        </a>
                    </li>
                    <!-- <li class="nav-item">
                        <a Class="nav-link" routerLinkActive="active" [routerLink]='["/statistical-data/export-data"]'>
                            Import & Export
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
    </nav>
</div>